import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservableErrorMonitorError, RpcObservableErrorMonitorKey, RpcObservableErrorMonitorRequest, RpcObservableErrorMonitorResult
} from './rpc-observable-error-monitor-model';

export class RpcObservableErrorMonitorClient
    extends RpcObservableClient<RpcObservableErrorMonitorRequest, RpcObservableErrorMonitorResult, RpcObservableErrorMonitorError>  {

    /**
     * Initializes a new instance of the RpcObservableErrorMonitorClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableErrorMonitorKey.command, RpcObservableErrorMonitorKey.version);
    }

    /**
     * The report command.
     *
     * @param request the Rpc Error Monitor data object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableMonitorResult> the observable object.
     */
    public report(request: RpcObservableErrorMonitorRequest, outbound?: RpcOutbound): Observable<RpcObservableErrorMonitorResult> {
        return this.observableCall(request, outbound);
    }
}
